import {getResidentTestId} from "../../helper";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {getAdmissionViewHref} from "../../../dashboard-cell/admissionRoutes";
import {getWorkflowLabel} from "../../../dashboard-cell/WorkflowRibbon";

import {StyledDropdownMenuItem} from "./styles";

export const ViewAdmissionDropdownItem = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => (
  <StyledDropdownMenuItem
    asLink
    to={getAdmissionViewHref(admission.id)}
    testId={getResidentTestId(admission, "view")}
    target="_blank"
  >
    View{" "}
    {
      // Default to admission because all old admissions are of type admission but they don't have a workflowType on them.
      getWorkflowLabel(admission.workflowType) ?? "Admission"
    }
  </StyledDropdownMenuItem>
);
